import { render } from "./TdmPredictRes.vue?vue&type=template&id=b5b073b8&scoped=true&ts=true"
import script from "./TdmPredictRes.vue?vue&type=script&lang=ts"
export * from "./TdmPredictRes.vue?vue&type=script&lang=ts"

import "./TdmPredictRes.vue?vue&type=style&index=0&id=b5b073b8&scoped=true&lang=css"
import "./TdmPredictRes.vue?vue&type=style&index=1&id=b5b073b8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b5b073b8"]])

export default __exports__